// extracted by mini-css-extract-plugin
module.exports = {"backButton":"_1Nbt4OIIBTR_4TYE-p_Osi"};